import { Platform, useWindowDimensions } from "@-/com.npmjs.react-native";
import {
  Skeleton,
  SkeletonSurfaceHeader,
  SkeletonTileGrid,
} from "@-/dev.improve.haniverse.components.ui.skeleton";
import { Surface } from "@-/dev.improve.haniverse.components.ui.surface";
import { getPrimitiveGridMetrics } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives._components.primitive-list-row";
import { BrowseFloatingToolbarSkeletonPage } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._components.loading-skeletons";
import { useHasHydrated } from "@-/dev.improve.haniverse.lib.hydration";

/** Collapsed primitive cards: glyph tile + gloss/rank lines + "View all", over two compound rows. */
export function BrowsePrimitivesCompoundsSkeleton() {
  const { width } = useWindowDimensions();
  const hasHydrated = useHasHydrated();
  const { cellSize, columns } = getPrimitiveGridMetrics(
    hasHydrated ? width : 0,
    Platform.OS === "web",
  );
  const tileStyle = { height: cellSize, width: cellSize };
  return (
    <BrowseFloatingToolbarSkeletonPage
      accessibilityLabel="Loading compounds"
      testID="browse-primitives-compounds-skeleton"
    >
      {[0, 1, 2, 3].map((key) => (
        <Surface key={key}>
          <SkeletonSurfaceHeader
            className="px-2"
            leading={<Skeleton style={tileStyle} />}
            titleClassName="w-28"
            trailing={<Skeleton className="h-3 w-14" />}
          />
          <SkeletonTileGrid className="p-1" columns={columns} />
        </Surface>
      ))}
    </BrowseFloatingToolbarSkeletonPage>
  );
}
